import { Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { RestService } from '../../../../shared/services/rest.service';
import { ToastService } from '../../../../shared/services/toast.service';
import { UserRepository } from '../../../user/states/user.repository';
import { AnimalQuarantineModel, AnimalQuarantineCreatePayload, AnimalQuarantineUpdatePayload } from '../../models/medical/animal-quarantine.model';
import { AnimalMedicalCrudRepository } from './animal-medical-crud.repository';

@Injectable({ providedIn: 'root' })
export class AnimalQuarantineRepository extends AnimalMedicalCrudRepository<AnimalQuarantineModel, AnimalQuarantineCreatePayload, AnimalQuarantineUpdatePayload> {
  protected readonly path = '/animal_quarantines';
  protected readonly toastKey = 'quarantine';

  constructor(
    restService: RestService,
    toast: ToastService,
    translateService: TranslocoService,
    userRepository: UserRepository
  ) {
    super(restService, toast, translateService, userRepository);
  }
}
